import { camelCase } from 'lodash-es';

export class Sensitive {

	static readonly jwt = 'jwt';

	static readonly refreshToken = 'refreshToken';

	static readonly accessToken = 'accessToken';

	static readonly password = 'password';

	static readonly confirmPassword = 'confirmPassword';

	static readonly currentPassword = 'currentPassword';

	static readonly newPassword = 'newPassword';

	static readonly confirmNewPassword = 'confirmNewPassword';

	static readonly primaryAccountNumber = 'primaryAccountNumber';

	static readonly cardNumber = 'cardNumber';

	static readonly creditCardNumber = 'creditCardNumber';

	static readonly paymentCardNumber = 'paymentCardNumber';

	static readonly acctNumber = 'acctNumber';

	static readonly cvv = 'cvv';

	static readonly cvv2 = 'cvv2';

	static readonly paymentCardCvv = 'paymentCardCvv';

	static readonly email = 'email';

	static readonly phoneNumber = 'phoneNumber';

	static readonly phone = 'phone';

}

const sensitiveKeys = new Set(Object.keys(Sensitive));

// Additional sensitive identifiers not exposed as typed payload keys on `Sensitive`
// (e.g. HTTP headers, generic token aliases). Kept separate so DTOs cannot reference
// them via `[Sensitive.cookie]: string` etc.
const additionalSensitiveKeys = new Set([
	'authorization',
	'proxyAuthorization',
	'cookie',
	'setCookie',
	'xApiKey',
	'apiKey',
	'xAuthToken',
	'authToken',
	'xAccessToken',
	'xRefreshToken',
	'xCsrfToken',
	'csrfToken',
	'turnstileToken',
	'secret',
	'cardNumber',
	'pan',
	'iban',
	'bic',
	'swift',
	'bankAccountNumber',
	'routingNumber',
	'merchantToken',
	'paymentDetails',
].map(key => camelCase(key)));

export function isSensitiveKey(key: string): boolean {
	const camelCased = camelCase(key);

	return sensitiveKeys.has(camelCased) || additionalSensitiveKeys.has(camelCased);
}

export const TELEMETRY_HIDDEN_MARK = '(Secret)';

export const OBSCURED_LITERAL = '[FILTERED]';
